import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'

export type RemoveCustomGatewaySettingAction = FSA<undefined, number, string>
type RemoveCustomGatewaySettingColor = (customGatewaySettingId: number) => MrxThunk<RemoveCustomGatewaySettingAction, Promise<boolean>>
type QueryResponse = GraphQLResponse<'removeCustomGatewaySetting', boolean>

const REMOVE_CUSTOM_GATEWAY_SETTING = `
  mutation removeCustomGatewaySetting ($customGatewaySettingId: Int!) {
    removeCustomGatewaySetting(customGatewaySettingId: $customGatewaySettingId)
  }
`

const removeCustomGatewaySetting: RemoveCustomGatewaySettingColor = (customGatewaySettingId) => async (dispatch) => {
  let isRemoved = false

  dispatch({
    type: t.REMOVE_CUSTOM_GATEWAY_SETTING,
    meta: { done: false }
  })

  try {
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: REMOVE_CUSTOM_GATEWAY_SETTING,
      variables: { customGatewaySettingId }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Empty response!')
    }

    const { removeCustomGatewaySetting } = data
    if (!removeCustomGatewaySetting) {
      throw new Error("Can't remove custom gateway setting!")
    }

    dispatch({
      type: t.REMOVE_CUSTOM_GATEWAY_SETTING,
      payload: customGatewaySettingId,
      meta: { done: true }
    })

    isRemoved = true
  } catch (err) {
    dispatch({
      type: t.REMOVE_CUSTOM_GATEWAY_SETTING,
      payload: extractErrorInfo(err),
      error: true
    })
  }

  return isRemoved
}

export { removeCustomGatewaySetting }
